import React, { useEffect, useMemo, useState } from 'react';
import Formsy from 'formsy-react';
import { useDispatch, useSelector } from 'react-redux';
import DocumentGallery from '../DocumentGallery';
import FormFields from "../formFields/coBorrowerDetailsFormFields.json";
import FormsyInputField from '../../elements/FormsyInputField';
import FormsySelect from '../../elements/FormsySelect';
import { useOutletContext, useNavigate, useParams } from 'react-router-dom';
import { CHECK_ASSIGN_USER, COBORROWER_PRIMARY_DOC_ID, COBORROWER_SECONDARY_DOC_ID, SUB_STATUS_CODES } from "./../../../config/constants";
import LeadRemarkHistory from '../../lead-list/LeadRemarkHistory';
import Modal from '../../elements/Modal';
import { SAVE_COBORROWER_ADDITIONAL_DETAILS } from '../../../services/coborrower';
import { executeGraphQLMutation } from '../../../common/executeGraphQLQuery';
import { toast } from 'react-toastify';
import { useApolloClient } from '@apollo/client';
import { getLoanDetail } from '../../../store/action/allAction';
import { IS_USER_ACCESS_PAGE} from '../../../config/constants';
import { useAiIcon } from '../../hooks/useAiIcon';
import AiIcon from '../../elements/ImageAI';
import { SAVE_VIBER_DATA } from '../../../services/leads.gql';

const FORM_FIELDS = FormFields["ADDITIONAL_DETAILS"];
let DEPENDENTS_OPTIONS = Array.from({ length: 11 }, (_, index) => ({
  id: index,
  label: `${index}`,
  value: index,
}));


const AdditionalDetails = (props) => {
    const [additionalDetails, setAdditionalDetails] = useState({});
    const [orgadditionalDetails, setOrgAdditionalDetails] = useState({});
    const [allowSubmit, setAllowSubmit] = useState(false);
    const [ViewTimeLine, setViewTimeLine] = useState(false);
    const [showremarkform,setShowremarkform]=useState(false);
    const { masterdata, lead, remarksHistory} = useSelector(({masterdata, lead}) => ({
      masterdata,
      lead,
      remarksHistory:lead.remarksHistory || [],
      leadFiles: lead && (lead.leadDetail && (lead.leadDetail.leaddocs || [])),
    }));
    const context = useOutletContext();
    const documentCategoryList = context.docList || []
    const viberCoborrowerData = context?.viberData?.get_viber_column?.co_borrower || [];
    const { showAiIcon } = useAiIcon(additionalDetails, viberCoborrowerData);
    let navigate = useNavigate();
    let { lead_id } = useParams();

    const client = useApolloClient();
    const dispatch = useDispatch();
    let accessCondition = !IS_USER_ACCESS_PAGE("loanDetail", "co-borrower-additional-details")?.is_edit_access;
    if(!accessCondition){
      accessCondition=CHECK_ASSIGN_USER(lead?.leadDetail?.assign_to);
    }
    const user_information = useSelector((state) => state.user.user_information);
    const UserInfo = JSON.parse(user_information);
    let user_id = (UserInfo && UserInfo.id) ? UserInfo.id : 0;

    useEffect(() => {
      if (lead && lead.leadDetail && lead.leadDetail.co_borrower) {
        let originalData = { ...lead.leadDetail.co_borrower };
        let updatedData = { ...originalData };

        if (viberCoborrowerData) {
          Object.keys(viberCoborrowerData).forEach(key => {
            if (!updatedData[key] && viberCoborrowerData[key]) {
              updatedData[key] = viberCoborrowerData[key];
            }
          });
        }

        setOrgAdditionalDetails(originalData);
        setAdditionalDetails(updatedData);
      }
    }, [lead]);


    const restructureDocList = (docList,primary_doc_id=0) => {
      let docListOptions = [];
      docList.forEach(v => {
        if (v.doclang) {
          if( v?.doclang?.doc_id!==primary_doc_id) {
            docListOptions.push({
              id: v.doclang?.doc_id || "",
              label: v.doclang?.name || "",
              value: v.doclang?.doc_id || "",
            })
          }
        }
      });
      return docListOptions;
    }

    let ALL_OPTIONS = useMemo(() => {
      let options = masterdata ? {...masterdata.data} : {};
      let allDocList = context && context.docList;
      if (allDocList && allDocList.length) {
        let primaryDocList = allDocList.find(v => v.id === COBORROWER_PRIMARY_DOC_ID)?.child || [];
        let secondaryDocList = allDocList.find(v => v.id === COBORROWER_SECONDARY_DOC_ID)?.child || [];
      
        primaryDocList = restructureDocList(primaryDocList,additionalDetails.cb_secondary_doc_id);
        secondaryDocList = restructureDocList(secondaryDocList,additionalDetails.cb_primary_doc_id);
        options["primary_docList"] = primaryDocList || [];
        options["secondary_docList"] = secondaryDocList || [];
      }
      options["dependents"] = DEPENDENTS_OPTIONS;
      return options;
    }, [context, masterdata, additionalDetails]);
  
    const handleInputChange = event => {
        if (event.target.id) {
            setAdditionalDetails(currentValue => ({
                ...currentValue,
                [event.target.id]: event.target.value
            }))
        }
    }

    const handlePatternFormatChange = (data, field_name) => {
        if (field_name && data.value) {
            setAdditionalDetails(currentValue => ({
                ...currentValue,
                [field_name]: data.value
            }))
        }
    }

    const handleSelectChange = (data, field_name) => {
      if (data && field_name) {
        setAdditionalDetails(currentValue => ({
          ...currentValue,
          [field_name]: data.value
        }))
      }
    }

    const handleSubmit = () => {
      let lead_id = lead?.leadDetail?.id || "";
      let reqBody = {
        lead_id: lead_id,
        cb_primary_doc_id: additionalDetails.cb_primary_doc_id,
        cb_primary_card_no: additionalDetails.cb_primary_card_no,
        cb_secondary_doc_id: additionalDetails.cb_secondary_doc_id,
        cb_secondary_card_no: additionalDetails.cb_secondary_card_no,
        cb_qualification: additionalDetails.cb_qualification,
        cb_father_name: additionalDetails.cb_father_name,
        cb_mother_name: additionalDetails.cb_mother_name,
        cb_facebook_url: additionalDetails.cb_facebook_url,
        cb_tin_number: additionalDetails.cb_tin_number,
        updated_by: user_id || 0
      }
      
      Object.keys(reqBody).forEach(key => {
        if (reqBody[key] === "") reqBody[key] = null;
      });

      let viberReqBody = {
        lead_id: lead_id,
        parent_object_name: 'co_borrower',
        changed_object: {
          cb_primary_doc_id: additionalDetails.cb_primary_doc_id?.toString() || null,
          cb_primary_card_no: additionalDetails.cb_primary_card_no?.toString() || null,
          cb_secondary_doc_id: additionalDetails.cb_secondary_doc_id?.toString() || null,
          cb_secondary_card_no: additionalDetails.cb_secondary_card_no?.toString() || null,
          cb_qualification: additionalDetails.cb_qualification?.toString() || null,
          cb_father_name: additionalDetails.cb_father_name?.toString() || null,
          cb_mother_name: additionalDetails.cb_mother_name?.toString() || null,
          cb_facebook_url: additionalDetails.cb_facebook_url?.toString() || null,
          cb_tin_number: additionalDetails.cb_tin_number?.toString() || null
        }
      };

      let viberMutation = SAVE_VIBER_DATA;
      executeGraphQLMutation(viberMutation, viberReqBody, client)
        .then(resp => {
          console.log(resp);
        })
        .catch(err => console.log(err));

      let mutation = SAVE_COBORROWER_ADDITIONAL_DETAILS, 
          variables = { cb_additionalDetailsInput: reqBody };

      executeGraphQLMutation(mutation, variables, client).then(resp => {
        let response = resp?.data?.save_cb_additional_details || null;
        if (response && !response.success) {
          throw new Error(response.error || "Something went wrong");
        }
        toast.success("Success");
        dispatch(getLoanDetail(lead_id,client))
        navigateToNext();
      })
      .catch(err => {
        toast.error(err.message);
      })
    }

    const navigateToNext = () => {
      navigate(`/lead-detail/co-borrower-details/employment-details/${lead_id}`);
    }

    let AdditionalDetailsForm = FORM_FIELDS;

    // All the conditions can be combined here for button enable/disable
    const isSubmitDisabled = useMemo(() => {
    
      return lead.leadDetail.lead_status_history.filter(v=>v.sub_status_id===6).length ? true : false;
      
    }, [lead.leadDetail]);

    const showModalViewTimeLine = () => {
      setViewTimeLine(true);
      setShowremarkform(true);
      document.body.classList.add("overflow-hidden");
    };
  
    const hideModalViewTimeLine = () => {
      setViewTimeLine(false);
      document.body.classList.remove("overflow-hidden");
    };

    const sectionInfo = {section : "Co-borrower details" , sub_section : "Additional details"}
    let { BASIC_DETAILS_FILLED, LOAN_QUOTE_SELECTED, CUSTOMER_DETAIL_FILLED, APPLICATION_CREATED} = SUB_STATUS_CODES
    let isSubStatus3Marked = [BASIC_DETAILS_FILLED, LOAN_QUOTE_SELECTED, CUSTOMER_DETAIL_FILLED, APPLICATION_CREATED].includes(lead.leadDetail?.sub_status_id) ? false : true;        
    return (
      <div className="image-form-outer">
        <div className="image-tab-panel">
        <DocumentGallery documentCategoryList={documentCategoryList}  />
        </div>
        <div className="form-tab-right-panel">
          <div className="lead-detail-from-outer">
            <div className="lead-form-heading">
              <span className="main-heading">Co-Borrower Details</span>
              <h2>Additional Details</h2>
            </div>
            <Formsy
              className="lead-form-filed"
              autoComplete="off"
              onValid={() => setAllowSubmit(true)}
              onInvalid={() => setAllowSubmit(false)}
              onValidSubmit={handleSubmit}
            >
              <div className="row">
                
                {AdditionalDetailsForm.map((field) => (
                    ["text", "pattern-format"].includes(field.type) ? (
                  <fieldset class="form-filed col-md-6 ">
                    <FormsyInputField
                        id={field.id}
                        name={field.name}
                        type={field.type}
                        value={(additionalDetails ? additionalDetails[field.name] : '')}
                        placeholder=" "
                        label={field.label}
                        onChange={
                        field.type === "pattern-format" 
                        ? (data) => handlePatternFormatChange(data, field.name)
                        : handleInputChange
                        }
                        format={field.ApplyNumberformat ? field.format : ""}
                        validations={field.validations}
                        validationError={
                        additionalDetails[field.name] ? field.validationError : ""
                        }
                        required={field.required}
                        readOnly = {orgadditionalDetails[field.name] && isSubStatus3Marked ? true : false}
                    />
                  {showAiIcon(field.name) ? <AiIcon /> : null}
                  </fieldset>
                    ) : 
                    
                    field.type === "dropdown" ? (
                    <fieldset class="single-select col-md-6">
                      <FormsySelect
                        name={field.name}
                        id={field.id}
                        inputProps={{
                            options: ALL_OPTIONS && ALL_OPTIONS[field.optionsKey],
                            placeholder: field.label,
                            className: "react-select",
                            classNamePrefix: "react-select",
                            value: ALL_OPTIONS && ALL_OPTIONS[field.optionsKey] && ALL_OPTIONS[field.optionsKey].filter(({ value }) => value === (additionalDetails[field.name])),
                            isDisabled: field.readOnly || (orgadditionalDetails[field.name] && isSubStatus3Marked) ? true : false
                        }}
                        required={field.required}
                        value={additionalDetails[field.name]}
                        onChange={(data) => handleSelectChange(data, field.name)}
                      />
                    {showAiIcon(field.name) ? <AiIcon /> : null}
                    </fieldset>
                    ) : null 
                ))}
                
              </div>

              <div className="btn-save-remarks">
              {(isSubmitDisabled || !allowSubmit || context.markAsFreezedNewFlow || accessCondition) ? <span className="span-disabled">Save & Next</span> :
                <button aria-label="save next" type="submit" className="btn-primary" disabled={isSubmitDisabled || !allowSubmit || context.markAsFreezedNewFlow || accessCondition}>
                  Save & Next
                </button>
              } 
                <button aria-label="remarks history" type="button" className="btn-line" onClick={showModalViewTimeLine}>Remarks
                  <span className="m-xs-l">({remarksHistory && (remarksHistory.length || 0)})</span>
                </button>
              </div>
            </Formsy>
          </div>
        </div>
        <div className="view-timeline-popup">
          <Modal show={ViewTimeLine} handleClose={hideModalViewTimeLine} >
            <div className="modal-header">
              <h2>Remark History</h2>
            </div>
            <LeadRemarkHistory showremarkform={showremarkform} markAsFreezed={context.markAsFreezedNewFlow} accessCondition={accessCondition} sectionInfo = {sectionInfo}/>
          </Modal>
        </div>
      </div>
    );
}
export default AdditionalDetails;